module.exports = __webpack_public_path__ + "static/img/10.9f0dc0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/sp/10.png
// module id = JZWM
// module chunks = 0